<template>
  <div ref="component" class="content cx_style deng">
    <label v-if="titlePosition === 'singleLine'" class="font14 inlineMiddle mb8">{{ title }}</label>
    <div class="verticallyCenter">
      <span
        v-if="title.length && titlePosition === 'allInOneLine'"
        ref="title"
        class="font14 mr16 text"
        :style="getTitleStyle"
      >
        {{ title }}
      </span>
      <div class="floatLeft double_input_box" style="margin-right: 16px">
        <single-input
          :placeholder="placeHolderText"
          class="mr16"
          :value.sync="originSyncValue1"
          :inputSuffixs='typeof inputSuffixs === "string" ? inputSuffixs : inputSuffixs[0]'
        />
<!--        <el-input-->
<!--          :placeholder="placeHolderText"-->
<!--          class="mr16"-->
<!--          type="number"-->
<!--          v-inputHandle="{ this1, type: 'originSyncValue1' }"-->
<!--          @blur="setValue('originSyncValue1','syncValue1')"-->
<!--          v-model="syncValue1"-->
<!--          @focus="getFocus($event)"-->
<!--        >-->
<!--          <template slot="suffix">-->
<!--            <span class="suffix_text">{{ typeof inputSuffixs === "string" ? inputSuffixs : inputSuffixs[0] }}</span>-->
<!--          </template>-->
<!--        </el-input>-->
      </div>
      <div class="floatLeft double_input_box">
        <!--          <span class="font14 mr10">Y</span>-->
        <single-input
          :placeholder="placeHolderText"
          :value.sync="originSyncValue2"
          :inputSuffixs='typeof inputSuffixs === "string" ? inputSuffixs : inputSuffixs[1] '
        />
<!--        <el-input-->
<!--          :placeholder="placeHolderText"-->
<!--          class=""-->
<!--          type="number"-->
<!--          v-model="syncValue2"-->
<!--          v-inputHandle="{ this1, type: 'originSyncValue2' }"-->
<!--          @focus="getFocus($event)"-->
<!--          @blur="setValue('originSyncValue2','syncValue2')"-->
<!--        >-->
<!--          <template slot="suffix">-->
<!--            <span class="suffix_text">{{ typeof inputSuffixs === "string" ? inputSuffixs : inputSuffixs[1] }}</span>-->
<!--          </template>-->
<!--        </el-input>-->
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
export default {
  mixins: [publicData],
  name: "doubleInput",
  props: {
    title: {
      type: String,
      default: ""
    },
    value1: {
      required: true
    },
    value2: {
      required: true
    },
    placeHolderText: {
      type: String,
      default: "请输入内容"
    },
    titlePosition: {
      type: String,
      default: "allInOneLine"
    },
    inputSuffixs: {
      type: [String, Array],
      required: true
    }
  },
  // watch:{
  //   ids: {
  //     handler: function (newVal, oldVal) {
  //       this.initData()
  //     },
  //     immediate: true,
  //     deep: true
  //   },
  //   originSyncValue1(newVal, oldVal){
  //     if (newVal !== oldVal) {
  //       this.syncValue1 = newVal
  //     }
  //   },
  //   originSyncValue2(newVal, oldVal){
  //     if (newVal !== oldVal) {
  //       this.syncValue2 = newVal
  //     }
  //   },
  // },
  data() {
    return {
      // syncValue1:0,
      // syncValue2:0,
      inputWidth: {}
    }
  },
  mounted() {
    // this.updateWidth()
    // this.initData()
  },
  computed: {
    originSyncValue1: {
      get() {
        return !isNaN(this.value1) ? Number(this.value1) : undefined
      },
      set(val) {
        this.$emit("update:value1", Number(val))
      }
    },
    originSyncValue2: {
      get() {
        return !isNaN(this.value1) ? Number(this.value2) : undefined
      },
      set(val) {
        this.$emit("update:value2", Number(val))
      }
    },
    getTitleStyle() {
      return {
        fontSize: "14px"
      }
    }
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    },
    // initData(){
    //   this.syncValue1 = this.originSyncValue1
    //   this.syncValue2 = this.originSyncValue2
    // },
    updateWidth() {
      requestAnimationFrame(() => {
        const title = this.$refs.title
        const box = this.$refs.component
        const boxWidth = box.offsetWidth
        const titleTextLen = this.title.trim().length
        if (boxWidth && (title || titleTextLen === 0)) {
          const titleSize = titleTextLen !== 0 ? titleTextLen * 14 : 0
          this.inputWidth = { width: (boxWidth - titleSize - 16 * (!!titleSize * 2 || 1)) / 2 + "px" }
        } else {
          this.updateWidth()
        }
      })
    },
    // setValue(originName,name){
    //   if(this[name]){
    //     this[originName] = Number(this[name])
    //   }else{
    //     // 不允许输入为空 为空的情况恢复原来的值
    //     this[name] = Number(this[originName])
    //   }
    // }
  }
}
</script>

<style scoped>
.double_input_box {
  flex: 1;
}
.text{
  color: var(--text);
}
</style>
